import {
  DEV_DOMAIN,
  LOCAL_DOMAIN,
  K8S_DOMAIN,
  UAT_DOMAIN,
} from "../constants/routes";

const DOMAINS = [DEV_DOMAIN, UAT_DOMAIN];

export const isLocalDev = (hostname) => hostname.includes(LOCAL_DOMAIN);

const isNonProdEnv = (hostname) => DOMAINS.some((url) => hostname.includes(url));

export const getAppName = (hostname) =>
  isLocalDev(hostname) ? LOCAL_DOMAIN : K8S_DOMAIN;

export const getEmailDomain = (email) => email?.split("@")?.[1];

export const getKubernetesCluster = (hostname) => {
  if (isLocalDev(hostname)) {
    return "local";
  }

  return isNonProdEnv(hostname) ? hostname.split(".")?.[1] : "prod";
};

export const getKubernetesNamespaceAndApp = (hostname) => {
  if (isLocalDev(hostname)) {
    return LOCAL_DOMAIN;
  }

  return isNonProdEnv(hostname) ? hostname.split(".")?.[0] : "default";
};

export const getKubernetesNamespace = (namespaceAndApp) => {
  if (namespaceAndApp === LOCAL_DOMAIN) {
    return "local";
  }
  if (namespaceAndApp === "default") {
    return "prod";
  }
  const namespaceParts = namespaceAndApp.split("-");
  return namespaceParts
    .filter(
      (namespacePart) =>
        namespacePart !== "revenue" &&
        namespacePart !== "management" &&
        namespacePart !== "dashboard"
    )
    .join("-");
};
